import AsyncSelect from "../AsyncSelect/AsyncSelect";
import { withAPIKey } from "@aws/amazon-location-utilities-auth-helper";
import { AWS_LOCATION_KEY, AWS_LOCATION_PLACE_INDEX } from "../../../constants";
import { LocationClient } from "@aws-sdk/client-location";
import { SearchPlaceIndexForTextCommand } from "@aws-sdk/client-location";
import { normalizer } from "./utilities";
import { getAwsLocationOptionStyle } from "../AsyncSelect/utilities";
import { useTypes } from "../../../utilities/types";
import { dictionary } from "../../../utilities/dictionary";
import { useAppContext } from "../../../AppProvider";

const authHelper = await withAPIKey(AWS_LOCATION_KEY); // use API Key id for credentials

const client = new LocationClient({
  region: "eu-west-1",
  ...authHelper.getClientConfig(), // sets up the Location client to use the API Key defined above
});

const SearchLocality = ({
  name = "searchLocality",
  onChange,
  ref,
  placeholder = "",
  value,
}) => {
  const { locationLevels } = useTypes();
  const { dictionary } = useAppContext();

  const handleChange = (selector, option) => {
    if (onChange) {
      onChange(selector, option);
    }
  };

  const fetch = async (text) => {
    if (text) {
      const command = new SearchPlaceIndexForTextCommand({
        Text: text,
        IndexName: AWS_LOCATION_PLACE_INDEX,
        Language: "it",
      });
      return await client.send(command);
    }

    return { Results: [] };
  };

  return (
    <AsyncSelect
      name={name}
      ref={ref}
      placeholder={placeholder || dictionary.contacts.search_a_new_address}
      onSearch={handleChange}
      loadOptions={(text) => {
        return fetch(text).then((res) => {
          return { data: normalizer(res?.Results) };
        });
      }}
      optionStyle={(option) => {
        if (option?.place?.matchLevelCode) {
          return getAwsLocationOptionStyle(option, locationLevels);
        }
        return option.label;
      }}
      isClearable={false}
      searchOnOpen={false}
      value={value}
      noOptionsMessage={dictionary.contacts.type_to_enter_new_address}
    />
  );
};

export default SearchLocality;
